import {
  CreateMediaRecordRequest,
  FileUploadRepository,
  UploadTextFileRequest,
} from "@/application/upload/ports/FileUploadRepository";
import { fileUploadService } from "@/services/fileUpload.service";

export class InsightFileUploadRepository implements FileUploadRepository {
  async checkSpace(sizeMb: number): Promise<boolean> {
    return fileUploadService.checkSpace(sizeMb);
  }

  async createMediaRecord(
    request: CreateMediaRecordRequest,
    projectId?: string
  ): Promise<{ id: string; name: string; filePath: string }> {
    const result = await fileUploadService.uploadAudioFile(
      {
        record_name: request.recordName,
        file_path: request.filePath,
        duration: request.durationSec,
        size_mb: request.sizeMb,
        type: request.type,
      },
      projectId
    );

    return {
      id: result.id,
      name: result.name,
      filePath: result.file_path,
    };
  }

  async uploadTextFile(
    request: UploadTextFileRequest,
    projectId?: string
  ): Promise<{ id: string; name: string; filePath: string }> {
    const result = await fileUploadService.uploadTextFile(
      {
        record_name: request.recordName,
        content: request.content,
        file_extension: request.extension,
        transcript_format: request.transcriptFormat,
      },
      projectId
    );

    return {
      id: result.id,
      name: result.name,
      filePath: result.file_path,
    };
  }
}

